import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

/**
 * Insurance Badge Component
 * Displays a small badge indicating the product is covered by measurement insurance
 */

// Small badge for product cards - clickable link to insurance page
export const InsuranceBadgeSmall = ({ className = '' }) => (
  <Link 
    to="/assurance-mesure"
    onClick={(e) => e.stopPropagation()} // Prevent triggering product card click
    className={`absolute top-2 left-2 bg-celadon hover:bg-celadon/90 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1 shadow-md z-10 transition-colors ${className}`}
    title="Assurance Prise de Mesure incluse - Cliquez pour en savoir plus"
  >
    <Shield className="w-3 h-3" />
    <span>Assuré</span>
  </Link>
);

// Medium badge for product detail page
export const InsuranceBadgeMedium = ({ showLink = true }) => (
  <div className="bg-green-50 border border-green-200 rounded-lg p-4">
    <div className="flex items-start gap-3">
      <div className="bg-celadon p-2 rounded-full">
        <Shield className="w-5 h-5 text-white" />
      </div>
      <div className="flex-1">
        <h4 className="font-semibold text-gray-900 mb-1">
          Assurance Prise de Mesure incluse
        </h4>
        <p className="text-sm text-gray-600 mb-2">
          Erreur de mesure ? Nous refabriquons gratuitement votre toile.
        </p>
        {showLink && (
          <Link 
            to="/assurance-mesure" 
            className="text-sm text-celadon hover:underline font-medium"
          >
            En savoir plus →
          </Link>
        )}
      </div>
    </div>
  </div>
);

// Large banner for cart/checkout
export const InsuranceBanner = () => (
  <div className="bg-gradient-to-r from-celadon to-emerald-600 text-white rounded-lg p-4 mb-4">
    <div className="flex items-center gap-3">
      <Shield className="w-8 h-8 flex-shrink-0" />
      <div>
        <p className="font-semibold">Assurance Prise de Mesure incluse</p>
        <p className="text-sm opacity-90">
          Vos toiles sur mesure sont couvertes en cas d'erreur de mesure.{' '}
          <Link to="/assurance-mesure" className="underline hover:no-underline">
            Voir les conditions
          </Link>
        </p>
      </div>
    </div>
  </div>
);

// Inline text link for hero/footer
export const InsuranceLink = ({ className = '' }) => (
  <Link 
    to="/assurance-mesure"
    className={`inline-flex items-center gap-1 hover:underline ${className}`}
  >
    <Shield className="w-4 h-4" />
    <span>Assurance Prise de Mesure</span>
  </Link>
);

export default InsuranceBadgeSmall;
